import { theme } from '@reveni-io/reveni-ui'

export const replaceColorsByStoreThemeColors = (colors, storeThemeColors) => {
  const newColors = {}

  Object.entries(colors).forEach(([groupColorKey, group]) => {
    newColors[groupColorKey] = {
      ...group,
      types: {},
    }

    Object.entries(group.types).forEach(([typeKey, type]) => {
      const newTypeColors = {}

      Object.entries(type.colors).forEach(([colorKey, color]) => {
        newTypeColors[colorKey] = {
          ...color,
          color: storeThemeColors?.[color.backendName] || color.color,
        }
      })

      newColors[groupColorKey].types[typeKey] = {
        ...type,
        colors: newTypeColors,
      }
    })
  })

  return newColors
}

export const getDefaultColors = () => {
  return {
    brandColors: {
      label: 'Colores de marca',
      types: {
        primary: {
          colors: {
            primaryBrandColor: {
              color: '#111111',
              label: 'Color de marca primario',
              backendName: 'primary_brand_color',
            },
          },
        },
      },
    },
    splitButtonColors: {
      label: 'Selectores de método / solicitud',
      types: {
        normal: {
          label: 'Normal',
          colors: {
            splitButtonBackgroundColor: {
              color: theme.legacy.splitButton.backgroundColor,
              label: 'Fondo',
              backendName: 'split_button_background_color',
            },
            splitButtonBorderColor: {
              color: theme.legacy.splitButton.borderColor,
              label: 'Borde',
              backendName: 'split_button_border_color',
            },
            splitButtonColor: {
              color: theme.legacy.splitButton.color,
              label: 'Texto',
              backendName: 'split_button_text_color',
            },
            splitButtonIconColor: {
              color: theme.legacy.splitButton.iconColor,
              label: 'Icono',
              backendName: 'split_button_icon_color',
            },
          },
        },
        hover: {
          label: 'Hover',
          colors: {
            splitButtonHoverBackgroundColor: {
              color: theme.legacy.splitButton.hover.backgroundColor,
              label: 'Fondo',
              backendName: 'split_button_background_hover_color',
            },
            splitButtonHoverBorderColor: {
              color: theme.legacy.splitButton.hover.borderColor,
              label: 'Borde',
              backendName: 'split_button_border_hover_color',
            },
            splitButtonHoverColor: {
              color: theme.legacy.splitButton.hover.color,
              label: 'Texto',
              backendName: 'split_button_text_hover_color',
            },
            splitButtonHoverIconColor: {
              color: theme.legacy.splitButton.hover.iconColor,
              label: 'Icono',
              backendName: 'split_button_icon_hover_color',
            },
          },
        },
        selected: {
          label: 'Seleccionado',
          colors: {
            splitButtonSelectedBackgroundColor: {
              color: theme.legacy.splitButton.selected.backgroundColor,
              label: 'Fondo',
              backendName: 'split_button_background_selected_color',
            },
            splitButtonSelectedBorderColor: {
              color: theme.legacy.splitButton.selected.borderColor,
              label: 'Borde',
              backendName: 'split_button_border_selected_color',
            },
            splitButtonSelectedColor: {
              color: theme.legacy.splitButton.selected.color,
              label: 'Texto',
              backendName: 'split_button_text_selected_color',
            },
            splitButtonSelectedIconColor: {
              color: theme.legacy.splitButton.selected.iconColor,
              label: 'Icono',
              backendName: 'split_button_icon_selected_color',
            },
          },
        },
      },
    },
    variantButtonColors: {
      label: 'Selector de variante',
      types: {
        normal: {
          label: 'Normal',
          colors: {
            variantButtonBackgroundColor: {
              color: theme.legacy.colors.outline.default,
              label: 'Fondo',
              backendName: 'variant_background_color',
            },
            variantButtonBorderColor: {
              color: theme.legacy.colors.text.default,
              label: 'Borde',
              backendName: 'variant_border_color',
            },
            variantButtonColor: {
              color: theme.legacy.colors.text.inverse,
              label: 'Texto',
              backendName: 'variant_text_color',
            },
          },
        },
        hover: {
          label: 'Hover',
          colors: {
            variantButtonHoverBackgroundColor: {
              color: theme.legacy.colors.outline.default,
              label: 'Fondo',
              backendName: 'variant_background_hover_color',
            },
            variantButtonHoverBorderColor: {
              color: theme.legacy.colors.text.default,
              label: 'Borde',
              backendName: 'variant_border_hover_color',
            },
            variantButtonHoverColor: {
              color: theme.legacy.colors.text.inverse,
              label: 'Texto',
              backendName: 'variant_text_hover_color',
            },
          },
        },
        disabled: {
          label: 'Deshabilitado',
          colors: {
            variantButtonDisabledBackgroundColor: {
              color: theme.legacy.button.primary.disabled.backgroundColor,
              label: 'Fondo',
              backendName: 'variant_background_disabled_color',
            },
            variantButtonDisabledBorderColor: {
              color: theme.legacy.button.primary.disabled.borderColor,
              label: 'Borde',
              backendName: 'variant_border_disabled_color',
            },
            variantButtonDisabledColor: {
              color: theme.legacy.colors.text.inverse,
              label: 'Texto',
              backendName: 'variant_text_disabled_color',
            },
          },
        },
        selected: {
          label: 'Seleccionado',
          colors: {
            variantButtonSelectedBackgroundColor: {
              color: theme.legacy.colors.text.default,
              label: 'Fondo',
              backendName: 'variant_background_selected_color',
            },
            variantButtonSelectedBorderColor: {
              color: theme.legacy.colors.text.default,
              label: 'Borde',
              backendName: 'variant_border_selected_color',
            },
            variantButtonSelectedColor: {
              color: theme.legacy.colors.text.inverse,
              label: 'Texto',
              backendName: 'variant_text_selected_color',
            },
          },
        },
      },
    },
    buttonColors: {
      label: 'Botones primarios',
      types: {
        normal: {
          label: 'Normal',
          colors: {
            buttonBackgroundColor: {
              color: theme.legacy.button.primary.backgroundColor,
              label: 'Fondo',
              backendName: 'button_background_color',
            },
            buttonBorderColor: {
              color: theme.legacy.colors.text.default,
              label: 'Borde',
              backendName: 'button_border_color',
            },
            buttonColor: {
              color: theme.legacy.button.primary.color,
              label: 'Texto',
              backendName: 'button_text_color',
            },
          },
        },
        hover: {
          label: 'Hover',
          colors: {
            buttonHoverBackgroundColor: {
              color: theme.legacy.button.primary.backgroundColor,
              label: 'Fondo',
              backendName: 'button_background_hover_color',
            },
            buttonHoverBorderColor: {
              color: theme.legacy.colors.text.default,
              label: 'Borde',
              backendName: 'button_border_hover_color',
            },
            buttonHoverColor: {
              color: theme.legacy.button.primary.color,
              label: 'Texto',
              backendName: 'button_text_hover_color',
            },
          },
        },
        disabled: {
          label: 'Deshabilitado',
          colors: {
            buttonDisabledBackgroundColor: {
              color: theme.legacy.button.primary.disabled.backgroundColor,
              label: 'Fondo',
              backendName: 'button_background_disabled_color',
            },
            buttonDisabledBorderColor: {
              color: theme.legacy.button.primary.disabled.borderColor,
              label: 'Borde',
              backendName: 'button_border_disabled_color',
            },
            buttonDisabledColor: {
              color: theme.legacy.button.primary.disabled.color,
              label: 'Texto',
              backendName: 'button_text_disabled_color',
            },
          },
        },
      },
    },
    buttonSimpleColors: {
      label: 'Botones simples',
      types: {
        normal: {
          label: 'Normal',
          colors: {
            buttonSimpleColor: {
              color: theme.legacy.colors.outline.default,
              label: 'Texto',
              backendName: 'button_simple_text_color',
            },
          },
        },
        hover: {
          label: 'Hover',
          colors: {
            buttonSimpleHoverColor: {
              color: theme.legacy.colors.text.default,
              label: 'Texto',
              backendName: 'button_simple_text_hover_color',
            },
          },
        },
        disabled: {
          label: 'Deshabilitado',
          colors: {
            buttonSimpleDisabledColor: {
              color: theme.legacy.colors.text.inverse,
              label: 'Texto',
              backendName: 'button_simple_text_disabled_color',
            },
          },
        },
      },
    },
    linkColors: {
      label: 'Enlaces',
      types: {
        normal: {
          label: 'Normal',
          colors: {
            linkColor: { color: theme.legacy.link.color, label: 'Texto', backendName: 'link_color' },
          },
        },
        hover: {
          label: 'Hover',
          colors: {
            linkHover: {
              color: theme.legacy.link.hover,
              label: 'Texto',
              backendName: 'link_hover_color',
              orientation: 'top',
            },
          },
        },
      },
    },
  }
}
